"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COAPPLICANT_MINOR_AGE_MAX_VALUE = exports.COAPPLICANT_FIELDS = void 0;
var entities_1 = require("@common/entities");
var constants_1 = require("../constants");
exports.COAPPLICANT_FIELDS = [
    __assign(__assign({}, entities_1.CoApplicantFields.ageOver17), { type: entities_1.FieldType.Radio, sequence: 1, customType: entities_1.FieldType.Radio, required: true, enabled: true, options: constants_1.YES_NO_OPTIONS.map(function (option) { return (__assign(__assign({}, option), { testKey: "age_over_17_".concat(option.value) })); }), defaultValue: 'yes', nonRemovable: true }),
    __assign(__assign({}, entities_1.CoApplicantFields.firstName), { type: entities_1.FieldType.Text, sequence: 2, customType: entities_1.FieldType.Text, required: true, enabled: true, nonRemovable: true }),
    __assign(__assign({}, entities_1.CoApplicantFields.middleName), { type: entities_1.FieldType.Text, sequence: 3, customType: entities_1.FieldType.Text, required: false, enabled: true, nonRemovable: true }),
    __assign(__assign({}, entities_1.CoApplicantFields.lastName), { type: entities_1.FieldType.Text, sequence: 4, customType: entities_1.FieldType.Text, required: true, enabled: true, nonRemovable: true }),
    __assign(__assign({}, entities_1.CoApplicantFields.email), { type: entities_1.FieldType.Email, sequence: 5, customType: entities_1.FieldType.Email, required: true, enabled: true, nonRemovable: true }),
    __assign(__assign({}, entities_1.CoApplicantFields.phoneNumber), { type: entities_1.FieldType.PhoneNumber, sequence: 6, customType: entities_1.FieldType.PhoneNumber, required: true, enabled: true, nonRemovable: true }),
    __assign(__assign({}, entities_1.CoApplicantFields.dateOfBirth), { sequence: 7, required: true, enabled: true, type: entities_1.FieldType.Date, customType: entities_1.FieldType.Date, nonRemovable: true }),
    __assign(__assign({}, entities_1.CoApplicantFields.relationshipToApplicant), { type: entities_1.FieldType.Dropdown, sequence: 8, customType: entities_1.FieldType.Dropdown, required: true, enabled: true, nonRemovable: true }),
    __assign(__assign({}, entities_1.CoApplicantFields.minorDateOfBirth), { type: entities_1.FieldType.Date, sequence: 9, customType: entities_1.FieldType.Date, required: false, enabled: true, nonRemovable: false }),
    // BP 10/24/24 Hiding this button for now DEV-142303
    // {
    //   label: 'Allow Primary to fill out form for co-applicants',
    //   type: FieldType.Radio,
    //   sequence: 3,
    //   name: 'allow_primary_enter_coapplicant_info',
    //   customType: FieldType.Radio,
    //   required: false,
    //   enabled: true,
    // },
];
exports.COAPPLICANT_MINOR_AGE_MAX_VALUE = 18;
